import { cssVar } from './cssVar'

export const radiusTokens = {
  xs: cssVar('--app-radius-xs'),
  sm: cssVar('--app-radius-sm'),
  md: cssVar('--app-radius-md'),
  layout: cssVar('--app-radius-layout'),
  lg: cssVar('--app-radius-lg'),
  xl: cssVar('--app-radius-xl'),
  squircleRatio: cssVar('--app-squircle-ratio'),
  cornerShape: cssVar('--app-corner-shape'),
  briefingInner: cssVar('--app-radius-briefing-inner'),
  toolkitInner: cssVar('--app-radius-toolkit-inner'),
}
